import request from '@/utils/request';
const baseURLAdmin = process.env.VUE_APP_ADMIN;
// 应发件规则分页查询
export const shipmentsRulePageQuery = (data) => {
  return request({
    url: '/shipmentsRule/pageQuery',
    method: 'post',
    data,
    baseURL: baseURLAdmin
  });
};
// 获取发车转运中心、下一站流向选项
export const getTransferCenterAndNextStation = (data) => {
  return request({
    url: '/shipmentsRule/queryDataSource',
    method: 'post',
    data,
    baseURL: baseURLAdmin
  });
};
// 新增应发件规则
export const addShipmentsRule = (data) => {
  return request({
    url: '/shipmentsRule/add',
    method: 'post',
    data,
    baseURL: baseURLAdmin
  });
};
// 修改应发件规则
export const updateShipmentsRule = (data) => {
  return request({
    url: '/shipmentsRule/edit',
    method: 'post',
    data,
    baseURL: baseURLAdmin
  });
};
// 删除应发件规则
export const deleteShipmentsRule = (data) => {
  return request({
    url: '/shipmentsRule/del?id=' + data,
    method: 'delete',
    baseURL: baseURLAdmin
  });
};
// 导出应发件规则
export const exportShipmentsRule = (data) => {
  return request({
    url: '/shipmentsRule/exportAll',
    method: 'post',
    data,
    baseURL: baseURLAdmin
  });
};
